import { render, staticRenderFns } from "./businesshours.vue?vue&type=template&id=7edb8fce&scoped=true&lang=pug&"
import script from "./businesshours.vue?vue&type=script&lang=js&"
export * from "./businesshours.vue?vue&type=script&lang=js&"
import style0 from "./businesshours.vue?vue&type=style&index=0&id=7edb8fce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7edb8fce",
  null
  
)

export default component.exports